import { useState, useEffect } from "react";

import DistrictControlPanel from "../controlPanel/DistrictControlPanel";
import useCurrentActionCache from "src/hooks/useCurrentActionCache";
import { CACHE_DISTRICT } from "src/constants/actionCache";
import { getListWard } from "src/apis/ADB/ward.api";
import { NotifyConfirm, Toast } from "src/components/notify/Notify";
import { dataStateType } from "src/constants/status";
import DistrictTable from "../Table/DistrictTable";
import { path } from "src/constants/path";
import Pagination from "src/components/Pagination/Pagination";
import useControlPanel from "src/hooks/useControlPanel";
import { defaultDistrict, defaultProvince } from "../../utils";
import Controls from "src/components/form/controls/Controls";
import {
  createDistrict,
  getListDistrict,
  removeDistrict,
  updateDistrict,
} from "src/apis/ADB/district.api";

const Districts = ({
  provinceId = defaultProvince.id,
  districtId = defaultDistrict.id,
  setDistrictId,
}) => {
  const [listDistrict, setListDistrict] = useState([defaultDistrict]);
  const { currentActionCache, setCurrentActionCache } = useCurrentActionCache();
  const [openPopup, setOpenPopup] = useState(false);
  const [recordForEdit, setRecordForEdit] = useState(null);

  const {
    numberPage,
    setNumberPage,
    limit,
    handleChangePage,
    startIndex,
    endIndex,
  } = useControlPanel();

  useEffect(() => {
    getListDistrict({ provinceId }, (result) => {
      setDistrictId(defaultDistrict.id);
      setListDistrict([defaultDistrict, ...result]);
    });
    setNumberPage(1);
  }, [provinceId, setDistrictId, setNumberPage]);

  const handleOnChange = (e) => {
    const { value } = e.target;
    setDistrictId(value);

    const indexSelected = listDistrict.findIndex(
      (district) => district.id === value
    );

    const currentPage = Math.ceil(indexSelected / limit);
    setNumberPage(currentPage);
  };

  const addOrEdit = (district, resetForm) => {
    if (district.id) {
      updateDistrict(district.id, district, (result) => {
        getListDistrict({ provinceId: provinceId }, (result) => {
          setDistrictId(defaultDistrict.id);
          setListDistrict([defaultDistrict, ...result]);
          setCurrentActionCache(CACHE_DISTRICT);
        });
      });
    } else {
      createDistrict(district, (result) => {
        getListDistrict({ provinceId: provinceId }, (result) => {
          setDistrictId(defaultDistrict.id);
          setListDistrict([defaultDistrict, ...result]);
          setCurrentActionCache(CACHE_DISTRICT);
          resetForm();
        });
      });
    }
  };

  const handleDelete = (district) => {
    getListWard({ districtId: district.id }, (result) => {
      if (result.length) {
        Toast("warning", "Quận/Huyện vẫn còn Phường/Xã, không thể xóa");
      } else {
        NotifyConfirm("warning", "Are you delete it ?", (result) => {
          if (result.isConfirmed) {
            removeDistrict(district.id, (result) => {
              getListDistrict({ provinceId: provinceId }, (result) => {
                setDistrictId(defaultDistrict.id);
                setListDistrict([defaultDistrict, ...result]);
                setCurrentActionCache(CACHE_DISTRICT);
              });
            });
          }
        });
      }
    });
  };

  const handleOpenPopup = (isOpen, item) => {
    setOpenPopup(isOpen);
    setRecordForEdit(item);
  };

  return (
    <div style={{ width: "100%", margin: "0 10px" }}>
      <Controls.AdministrativeSelect
        name="district"
        label="District"
        value={districtId}
        onChange={handleOnChange}
        options={listDistrict}
        optionField={{ key: "id", value: "districtName" }}
      />

      <DistrictControlPanel
        currentActionCache={currentActionCache}
        openPopup={openPopup}
        setOpenPopup={setOpenPopup}
        recordForEdit={recordForEdit}
        addOrEdit={addOrEdit}
        handleOpenPopup={handleOpenPopup}
      />

      <DistrictTable
        districtId={districtId}
        setDistrictId={setDistrictId}
        provinceId={provinceId}
        data={listDistrict.slice(startIndex + 1, endIndex + 1)}
        handleDelete={handleDelete}
        handleOpenPopup={handleOpenPopup}
        status={dataStateType.ACTIVE}
      />

      <Pagination
        pathname={path.cmsAdb}
        page={numberPage}
        handleChangePage={(page) => handleChangePage(page)}
        limit={limit}
        pageSize={listDistrict.length - 1}
      />
    </div>
  );
};

export default Districts;
